var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 11.666V6.70744C18.3333 6.68092 18.3228 6.65548 18.304 6.63673L13.3626 1.69531C13.3439 1.67655 13.3184 1.66602 13.2919 1.66602H7C5.89543 1.66602 5 2.56145 5 3.66602V16.3327C5 17.4373 5.89543 18.3327 7 18.3327H11.6667",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    stroke: "#808191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.66602V6.66602H18.3333",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#808191"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5.83398,
    width: 11.6667,
    height: 6.66667,
    rx: 1,
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35866 10.834V7.19762H2.7223C3.00166 7.19762 3.23603 7.2497 3.42543 7.35387C3.616 7.45804 3.75982 7.60127 3.85689 7.78356C3.95514 7.96467 4.00426 8.17063 4.00426 8.40146C4.00426 8.63465 3.95514 8.8418 3.85689 9.0229C3.75864 9.20401 3.61364 9.34665 3.42188 9.45082C3.23011 9.5538 2.99396 9.60529 2.71342 9.60529H1.80966V9.06374H2.62464C2.788 9.06374 2.92176 9.03533 3.02592 8.97852C3.13009 8.9217 3.20703 8.84357 3.25675 8.74414C3.30765 8.64471 3.3331 8.53048 3.3331 8.40146C3.3331 8.27243 3.30765 8.15879 3.25675 8.06055C3.20703 7.9623 3.1295 7.88595 3.02415 7.8315C2.91998 7.77586 2.78563 7.74805 2.62109 7.74805H2.0174V10.834H1.35866ZM5.80868 10.834H4.57644V7.19762H5.83354C6.19457 7.19762 6.50471 7.27042 6.76394 7.41602C7.02435 7.56043 7.2244 7.76817 7.36408 8.03924C7.50376 8.31031 7.5736 8.63465 7.5736 9.01225C7.5736 9.39104 7.50317 9.71656 7.3623 9.98881C7.22263 10.2611 7.0208 10.47 6.75684 10.6156C6.49405 10.7612 6.178 10.834 5.80868 10.834ZM5.23517 10.264H5.77672C6.03004 10.264 6.24133 10.2179 6.4106 10.1255C6.57987 10.032 6.70712 9.89293 6.79235 9.70827C6.87757 9.52243 6.92019 9.29042 6.92019 9.01225C6.92019 8.73408 6.87757 8.50326 6.79235 8.31978C6.70712 8.13512 6.58105 7.99722 6.41415 7.90607C6.24843 7.81374 6.04247 7.76758 5.79625 7.76758H5.23517V10.264ZM8.19949 10.834V7.19762H10.529V7.74982H8.85822V8.73704H10.3692V9.28924H8.85822V10.834H8.19949Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfReport);
export default __webpack_public_path__ + "static/media/pdf-report.32fd329437cf3d8f496bdeae9ff898e2.svg";
export { ForwardRef as ReactComponent };